import styled from "styled-components";
import { MainInner } from "@/styles/global";
import { GatsbyImage } from "gatsby-plugin-image";
import { ColorOptions } from "@/src/types";
import { StyledWysiwyg, TypographyProps } from "@/styles/typography";

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
  min-height: 70vh;
`;

const Inner = styled(MainInner)`
  display: flex;
  margin: auto;
  margin-bottom: 0;
  padding: 50px 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 62px 88px;
    margin: auto;
  }
`;

type BackgroundImageProps = {
  $overlay?: ColorOptions;
  $reverseOverlay?: boolean;
};

const BackgroundImage = styled(GatsbyImage)<BackgroundImageProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;

  &::before {
    content: "";
    position: absolute;
    background: ${({ theme, $overlay, $reverseOverlay }) =>
      $overlay &&
      `linear-gradient(
  ${$reverseOverlay ? 90 : 234}deg,
  ${theme.colors.black}00 0%,
  ${theme.colors[$overlay]}99 100%
)`};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  display: none;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
  }
`;

const MobileBackgroundImage = styled(GatsbyImage)<{ $overlay?: ColorOptions }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }

  &::before {
    content: "";
    position: absolute;
    background: ${({ theme, $overlay }) => theme.colors.black};
    opacity: 0.5;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
`;

const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  &::before {
    content: "";
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;

const TextContainer = styled.div<{
  alignLeft?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    gap: 24px;
    max-width: 60%;
    margin-left: ${({ alignLeft }) => (alignLeft ? "0" : "auto")};
  }
`;

const Text = styled(StyledWysiwyg)<TypographyProps>``;

const S = {
  Section,
  Inner,
  BackgroundImage,
  MobileBackgroundImage,
  VideoContainer,
  TextContainer,
  Text,
};

export default S;
